import { partsListApi } from '~/server'
import type { PartResponse } from '~/server/types'
import { LOAD_STATE } from '~/shared/types'

export function logicParts(partsClasszIds: number | number[], opt?: { clientOnly?: boolean }) {
  const state = ref(LOAD_STATE.INIT)
  const parts = ref<Record<number, { label: string, value: number }[]>>({})
  async function getHandle() {
    const res = await useLoadState({
      state,
      key: `issues-${partsClasszIds}`,
      onlyClient: opt?.clientOnly || true,
      fn: () => partsListApi(partsClasszIds),
    })

    if (!res)
      return
    parts.value = {}
    for (const key in res.data) {
      const list = []
      for (const item of res.data[key]) {
        list.push({
          label: item.name,
          value: item.id,
        })
      }
      parts.value[key] = list
    }
  }

  return {
    state,
    parts,
    getHandle,
  }
}

export function logicPartItem() {
  const state = ref(LOAD_STATE.INIT)
  const partsMap = ref(new Map<number, PartResponse[]>())
  async function getPart(partsClasszIds: number) {
    const res = await useLoadState({
      state,
      key: `issues-${partsClasszIds}`,
      onlyClient: true,
      fn: () => partsListApi(partsClasszIds),
    })

    if (!res)
      return

    partsMap.value.set(partsClasszIds, res.data[partsClasszIds])
  }

  return {
    state,
    getPart,
    partsMap,
  }
}
